import iconMarker from './icon-marker';

const renderAddress = ({
    propertyName = '',
    streetName = '',
    locality = '',
    town = '',
    postalCode = '',
}) => {
    let html = '';
    [propertyName, streetName, locality, town, postalCode].forEach(addressComponent =>
        html += `<div>${addressComponent}</div>`
    );
    return html;
};

const renderFacilities = (facilities) => {
    let html = '';
    if (facilities.length) {
        html += '<h3>Facilities</h3><ul class="currys-store__features">';
        facilities.forEach(facility => html += `<li>${facility}</li>`);
        html += '</ul>';
    }
    return html;
};

const renderStoreScheduleListItems = (schedule) => {
    let html = '';
    schedule.forEach(date => html += `
        <li class="currys-store__schedule-day">
            <span class="currys-store__schedule-date">${date.formattedDate}</span>
            <span class="currys-store__schedule-hours">${date.openingHours}</span>
        </li>
    `);
    return html.trim();
};

const renderStoresList = (stores) => {
    let html = '';
    stores.forEach((store, index) => {
        html += `
            <li class="currys-store" data-is-toggled="false">
                <div class="currys-store__top">
                    <div class="currys-store__marker-icon">
                        ${iconMarker}
                        <span class="currys-store__marker-count">
                            ${index + 1}
                        </span>
                    </div>
                    <div class="currys-store__desc">
                        <div class="currys-store__header">
                            <h3 class="currys-store__name">${store.branchName}</h3>
                            <div class="currys-store__distance">
                                ${store.distance} miles
                            </div>
                        </div>
                        <div class="currys-store__address">
                            ${renderAddress(store)}
                        </div>
                    </div>
                </div>
                <div class="currys-store__actions">
                    <a
                        href="javascript:void(0)"
                        class="link"
                        data-toggle-store-details
                    >
                        <span>Store details</span>
                        <span class="cpwicon cpwicon-arrow-down"></span>
                    </a>
                    <button
                        type="submit"
                        class="button button-secondary"
                        name="form[clickAndCollect][clickAndCollectBranchId]"
                        value="${store.storeCode}"
                    >
                        Deliver to this store
                    </button>
                </div>
                <div class="currys-store__details">
                    <h3>Opening Hours</h3>
                    <ul class="currys-store__opening-hours">
                        ${renderStoreScheduleListItems(store.schedule)}
                    </ul>
                    ${renderFacilities(store.facilities)}
                </div>
            </li>
        `;
    });
    return html.trim();
};

export default renderStoresList;
